import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    parameterTextField: {
        '&.MuiFormControl-marginDense': {
            marginBottom: theme.spacing(1),
        },
    },
    gridItemCont: {
        maxWidth: 212,
        marginLeft: 0,
        marginRight: 48,
    },
    textFieldValue: {
        fontSize: pxToRem(14),
        color: 'rgba(0, 0, 0, 0.54)',
        paddingTop: theme.spacing(0.5),
        '& .MuiInputBase-input': {
            textOverflow: 'ellipsis',
        },
    },
    label: {
        fontSize: pxToRem(12),
        opacity: 0.87,
        color: 'rgba(0, 0, 0, 0.54)',
        '&.MuiInputLabel-shrink': {
            transform: 'translate(0, -1.5px) scale(1)',
        },
    },
}))

interface ProjectParameterTextFieldProps {
    projectParameterName: string
    projectParameterValue?: string
    projectParameterId?: string
}

const ProjectParameterTextField: React.FC<ProjectParameterTextFieldProps> = ({
    projectParameterName,
    projectParameterValue,
    projectParameterId,
}) => {
    const classes = useStyles()
    const textElementRef = React.useRef<null | HTMLElement>(null)
    const [isOverflowed, setIsOverflowed] = React.useState(false)

    React.useEffect(() => {
        if (textElementRef) {
            const isOverflow =
                (textElementRef?.current?.scrollWidth ?? 0) >
                (textElementRef?.current?.offsetWidth ?? 0)
            setIsOverflowed(isOverflow)
        }
    }, [textElementRef, setIsOverflowed])
    return (
        <GridItem
            lg={6}
            md={6}
            sm={12}
            xs={12}
            className={classes.gridItemCont}
        >
            <HoverTooltip
                text={isOverflowed ? projectParameterValue : ''}
                placements={['bottom', 'top']}
            >
                <TextField
                    data-testid="projectParamTextFieldTestId"
                    margin="dense"
                    id={projectParameterId}
                    label={projectParameterName}
                    value={projectParameterValue}
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                        className: classes.label,
                    }}
                    InputProps={{
                        className: classes.textFieldValue,
                        readOnly: true,
                        inputRef: textElementRef,
                    }}
                    className={classes.parameterTextField}
                />
            </HoverTooltip>
        </GridItem>
    )
}

export default ProjectParameterTextField
